import React, { useEffect } from 'react';

function infinityRedirectPage() {
  useEffect(() => {
    if (window?.location) {
      const baseUrl = 'https://latitudefs.zendesk.com/hc/en-au/articles/49336084678161-Latitude-Infinity-Rewards-Visa-Decommission-FAQs';
      const queryParams = window.location.search;
      const redirectUrl = queryParams ? `${baseUrl}${queryParams}` : baseUrl;

      window.location.replace(redirectUrl);
    }
  }, []);

  return <></>;
}

export default infinityRedirectPage;